var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroupTransfer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    width: 240,
    height: 240,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 10,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 18,
    width: 56,
    height: 52,
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,70 V100 M50,100 H150 M50,100 V128 M150,100 V128"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 128,
    width: 56,
    height: 52,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122,
    y: 128,
    width: 56,
    height: 52,
    rx: 8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupTransfer);
export default __webpack_public_path__ + "static/media/group_transfer.2612e03e4a916cda69c3b10474eb7b55.svg";
export { ForwardRef as ReactComponent };